!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("powerbi-client"), require("react"), require("lodash.isequal")) : "function" == typeof define && define.amd ? define(["powerbi-client", "react", "lodash.isequal"], t) : "object" == typeof exports ? exports["powerbi-client-react"] = t(require("powerbi-client"), require("react"), require("lodash.isequal")) : e["powerbi-client-react"] = t(e["powerbi-client"], e.react, e["lodash.isequal"]);
}(window, function (e, t, r) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 3);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "EmbedType", function () {
      return c;
    }), r.d(t, "PowerBIEmbed", function () {
      return f;
    });
    var n = r(1),
        o = r(0),
        i = r(2),
        s = r.n(i);

    var _a,
        c,
        p = (_a = function a(e, t) {
      return (_a = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(e, t);
    }, function (e, t) {
      function r() {
        this.constructor = e;
      }

      _a(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
    }),
        u = function u(e, t, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function s(e) {
          try {
            c(n.next(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          try {
            c(n.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function c(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
            e(t);
          })).then(s, a);
        }

        c((n = n.apply(e, t || [])).next());
      });
    },
        l = function l(e, t) {
      var r,
          n,
          o,
          i,
          s = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function a(i) {
        return function (a) {
          return function (i) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; s;) {
              try {
                if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return s.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    s.label++, n = i[1], i = [0];
                    continue;

                  case 7:
                    i = s.ops.pop(), s.trys.pop();
                    continue;

                  default:
                    if (!(o = s.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      s = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      s.label = i[1];
                      break;
                    }

                    if (6 === i[0] && s.label < o[1]) {
                      s.label = o[1], o = i;
                      break;
                    }

                    if (o && s.label < o[2]) {
                      s.label = o[2], s.ops.push(i);
                      break;
                    }

                    o[2] && s.ops.pop(), s.trys.pop();
                    continue;
                }

                i = t.call(e, s);
              } catch (e) {
                i = [6, e], n = 0;
              } finally {
                r = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, a]);
        };
      }
    },
        d = function d() {
      for (var e = 0, t = 0, r = arguments.length; t < r; t++) {
        e += arguments[t].length;
      }

      var n = Array(e),
          o = 0;

      for (t = 0; t < r; t++) {
        for (var i = arguments[t], s = 0, a = i.length; s < a; s++, o++) {
          n[o] = i[s];
        }
      }

      return n;
    };

    !function (e) {
      e.Report = "report", e.Dashboard = "dashboard", e.Tile = "tile", e.Qna = "qna", e.Visual = "visual";
    }(c || (c = {}));

    var f = function (e) {
      function t(t) {
        var r = e.call(this, t) || this;
        return r.containerRef = n.createRef(), r.prevEventHandlerMapString = "", r.props.service ? r.powerbi = r.props.service : r.powerbi = new o.service.Service(o.factories.hpmFactory, o.factories.wpmpFactory, o.factories.routerFactory), r;
      }

      return p(t, e), Object.defineProperty(t.prototype, "embed", {
        get: function get() {
          return this._embed;
        },
        set: function set(e) {
          this._embed = e, this.invokeGetEmbedCallback();
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.componentDidMount = function () {
        this.containerRef.current && (this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl ? this.embedEntity() : this.embed = this.powerbi.bootstrap(this.containerRef.current, this.props.embedConfig)), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers);
      }, t.prototype.componentDidUpdate = function (e) {
        return u(this, void 0, void 0, function () {
          var t, r, n, o;
          return l(this, function (i) {
            switch (i.label) {
              case 0:
                return this.embedOrUpdateAccessToken(e), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers), s()(this.props.embedConfig.settings, e.embedConfig.settings) ? [3, 2] : [4, this.updateSettings()];

              case 1:
                i.sent(), i.label = 2;

              case 2:
                if (this.props.embedConfig.type !== c.Report) return [3, 11];
                i.label = 3;

              case 3:
                return i.trys.push([3, 10,, 11]), t = this.props.embedConfig, r = t.filters, n = e.embedConfig, t.pageName && t.pageName !== n.pageName ? [4, this.embed.setPage(t.pageName)] : [3, 5];

              case 4:
                i.sent(), i.label = 5;

              case 5:
                return !r || s()(r, n.filters) ? [3, 7] : [4, this.embed.setFilters(r)];

              case 6:
                return i.sent(), [3, 9];

              case 7:
                return r || !n.filters ? [3, 9] : [4, this.embed.removeFilters()];

              case 8:
                i.sent(), i.label = 9;

              case 9:
                return [3, 11];

              case 10:
                return o = i.sent(), console.error(o), [3, 11];

              case 11:
                return [2];
            }
          });
        });
      }, t.prototype.componentWillUnmount = function () {
        this.containerRef.current && this.powerbi.reset(this.containerRef.current);
      }, t.prototype.render = function () {
        return n.createElement("div", {
          ref: this.containerRef,
          className: this.props.cssClassName
        });
      }, t.prototype.embedEntity = function () {
        this.containerRef.current && (this.props.phasedEmbedding && this.props.embedConfig.type === c.Report ? this.embed = this.powerbi.load(this.containerRef.current, this.props.embedConfig) : (this.props.phasedEmbedding && console.error("Phased embedding is not supported for type " + this.props.embedConfig.type), this.embed = this.powerbi.embed(this.containerRef.current, this.props.embedConfig)));
      }, t.prototype.embedOrUpdateAccessToken = function (e) {
        this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl && (!this.containerRef.current || e.embedConfig.accessToken && this.props.embedConfig.embedUrl === e.embedConfig.embedUrl ? this.props.embedConfig.accessToken !== e.embedConfig.accessToken && this.props.embedConfig.embedUrl === e.embedConfig.embedUrl && this.embed && this.embed.setAccessToken(this.props.embedConfig.accessToken).catch(function (e) {
          console.error("setAccessToken error: " + e);
        }) : this.embedEntity());
      }, t.prototype.setEventHandlers = function (e, t) {
        var r = this,
            n = function (e) {
          if (!e) return "";
          var t = Array.from(e);
          return JSON.stringify(t.map(function (e) {
            return [e[0], e[1] ? e[1].toString() : ""];
          }));
        }(this.props.eventHandlers);

        if (this.prevEventHandlerMapString !== n) {
          this.prevEventHandlerMapString = n;
          var i = o.Embed.allowedEvents,
              s = e.embedtype;

          switch (s) {
            case c.Report:
              i = d(i, o.Report.allowedEvents);
              break;

            case c.Dashboard:
              i = d(i, o.Dashboard.allowedEvents);
              break;

            case c.Tile:
              i = d(i, o.Tile.allowedEvents);
              break;

            case c.Qna:
              i = d(i, o.Qna.allowedEvents);
              break;

            case c.Visual:
              i = d(i, o.Visual.allowedEvents);
              break;

            default:
              console.error("Invalid embed type " + s);
          }

          var a = [];
          t.forEach(function (t, n) {
            i.includes(n) ? (e.off(n), t && e.on(n, function (e) {
              t(e, r.embed);
            })) : a.push(n);
          }), a.length && console.error("Following events are invalid: " + a.join(","));
        }
      }, t.prototype.invokeGetEmbedCallback = function () {
        this.props.getEmbeddedComponent && this.embed && this.props.getEmbeddedComponent(this.embed);
      }, t.prototype.updateSettings = function () {
        return u(this, void 0, void 0, function () {
          var e, t;
          return l(this, function (r) {
            switch (r.label) {
              case 0:
                if (!this.embed || !this.props.embedConfig.settings) return [2];

                switch (this.props.embedConfig.type) {
                  case c.Report:
                    return [3, 1];

                  case c.Dashboard:
                  case c.Tile:
                  case c.Qna:
                  case c.Visual:
                    return [3, 6];
                }

                return [3, 7];

              case 1:
                e = this.props.embedConfig.settings, r.label = 2;

              case 2:
                return r.trys.push([2, 4,, 5]), [4, this.embed.updateSettings(e)];

              case 3:
                return r.sent(), [3, 5];

              case 4:
                return t = r.sent(), console.error("Error in method updateSettings: " + t), [3, 5];

              case 5:
              case 6:
                return [3, 8];

              case 7:
                console.error("Invalid embed type " + this.props.embedConfig.type), r.label = 8;

              case 8:
                return [2];
            }
          });
        });
      }, t;
    }(n.Component);
  }]);
});